import { ref } from 'vue'
import http from './http'

/**
 * IP 属地服务（原 https://www.yangtuoedu.com/cityjson 已废弃，统一改走 /ipaddr/ip2addr）
 * 直连绝对地址，dev 与 prod 拿到的都是同一份（正式）数据
 */
const IP2ADDR_URL = 'https://www.ytaxx.com/ipaddr/ip2addr'

export interface LocationInfo {
  country?: string
  city?: string
}

/** 用户 IP 属地信息（由 /ipaddr/ip2addr 接口获取） */
export const locationInfo = ref<LocationInfo | null>(null)

/** 用户是否在国内（IP 属地判断，默认 true，App.vue 中通过 provide('isChina') 提供给组件使用） */
export const isChina = ref(true)

let locationPromise: Promise<LocationInfo | null> | null = null

/**
 * 获取用户 IP 属地（会话级缓存，重复调用复用同一次请求；失败时保持默认值）
 * @returns 属地信息，取不到时为 null
 */
export const ensureLocation = (): Promise<LocationInfo | null> => {
  if (!locationPromise) {
    locationPromise = http
      .get(IP2ADDR_URL, {}, { skipMsg: true })
      .then((res: any) => {
        const data = res?.data ?? res
        if (!data || typeof data.country !== 'string') return null
        locationInfo.value = data
        isChina.value = data.country.indexOf('中国') !== -1
        return data as LocationInfo
      })
      .catch(() => null)
  }
  return locationPromise
}

/** 获取用户 IP 属地并更新 isChina / locationInfo */
export const fetchLocation = (): Promise<void> => {
  return ensureLocation().then(() => {})
}
